import { showItemReceivedNotification, showOfferSentPopup, showOfferPopup, acceptTrade, declineTrade, showReceiveBuyOfferPopup, handleRejectBuyOffer } from './offer.js';
import { showRedeemOfferPopup } from './redeemResult.js';
import { showTaxDecisionPopup, showPointsAssignedNotification, showtaxSingleItem, showPointsDeductedNotification, showItemSelectedAssign, displayNotification } from './tax.js';
import { fetchStocks, displayStocks, openStockTradeModal, showStockBidPopup } from './stockTrade.js';
import { connectWebSocket, socket, messageQueue } from './socketU.js';
import { initializeStealButton, handleStealButtonClick, displayAvailableItemsST, stealItem } from './button.js';
import { apiBaseUrl } from '../../backend/config.js';
import { t, confirmT, updateElementText } from './translationHelper.js';
import translations from './translations.js';

if (!globalThis.ZTranslations) {
  globalThis.ZTranslations = translations;
}

if (typeof globalThis.$t !== 'function') {
  globalThis.$t = (key, params) => {
  return t(key);
  };
}


let activeChatSession = null;

export function showMessagePopup(portfolios, currentUserId) {
  const existingPopup = document.getElementById('messagePopup');
  if (existingPopup) {
    existingPopup.remove();
  }

  // Debug: Log portfolios to check data integrity
  console.log('Portfolios received for message popup:', portfolios);

  const filteredPortfolios = portfolios.filter(p => {
    const isValid = p.active && p._id !== currentUserId && !p.isSuperUser;
    if (!p.name) {
      console.warn(`Portfolio with ID ${p._id} is missing the 'name' property.`);
    }
    return isValid;
  });

  const popup = document.createElement('div');
  popup.id = 'messagePopup';
popup.innerHTML = `
      <h2>${t('messageSend.title')}</h2>
      <p>${t('messageSend.costPerRecipient')}</p>
      <input 
        type="text" 
        id="recipientSearch" 
        placeholder="${t('messageSend.searchRecipients')}" 
        style="width: 100%; margin-bottom: 10px; padding: 5px;"
      />
      <div id="recipientList" style="max-height: 200px; overflow-y: auto; border: 1px solid #ccc; padding: 5px;">
        ${filteredPortfolios.map(p => `
          <div class="recipient" data-name="${(p.name || '').toLowerCase()}">
            <input type="checkbox" id="recipient-${p._id}" value="${p._id}">
            <label for="recipient-${p._id}">${p.name || t('messageSend.unnamedPortfolio')}</label>
          </div>
        `).join('')}
      </div>
      <textarea 
        id="messageContent" 
        maxlength="280" 
        placeholder="${t('messageSend.placeholder280')}" 
        style="width: 100%; margin-top: 10px; padding: 5px;"
      ></textarea>
      <button id="sendMessageBtn" style="margin-top: 10px;">${t('messageSend.send')}</button>
      <button id="closePopupBtn" style="margin-left: 10px;">${t('messageSend.close')}</button>
  `;

  document.body.appendChild(popup);
  popup.style.display = 'block';

  // Track popup state
  if (window.popupTracker) {
    const popupHandle = window.popupTracker.trackElement(popup, 'message');
  }

  const searchInput = document.getElementById('recipientSearch');
  const recipientList = document.getElementById('recipientList');

  // Implement search functionality
  searchInput.addEventListener('input', function () {
    const query = this.value.toLowerCase();
    const recipients = recipientList.querySelectorAll('.recipient');
    recipients.forEach(recipient => {
      const name = recipient.getAttribute('data-name');
      if (name.includes(query)) {
        recipient.style.display = 'block';
      } else {
        recipient.style.display = 'none';
      }
    });
  });

  // Close button functionality
  document.getElementById('closePopupBtn').addEventListener('click', () => {
    document.body.removeChild(popup);
  });

  // Sanitize message input
  document.getElementById('messageContent').addEventListener('input', function () {
    this.value = this.value.replace(/[^\w\s.,!?-]/gi, '');
  });
}


export function sendMessage(senderId, recipientPortfolioIds, content, senderName) {
  return new Promise((resolve, reject) => {
    if (content.length > 280) {
      reject('Message exceeds 280 characters.');
      return;
    }

    const sanitizedContent = content.replace(/[^\w\s.,!?-]/gi, '');

    socket.emit('sendMessage', { senderId, recipientPortfolioIds, content: sanitizedContent, senderName }, (response) => {
      if (response.success) {
        resolve(response.message);
      } else {
        console.error('Error sending message:', response.message);
        alert(response.message); // Display the error to the user
        reject(response.message);
      }
    });
  });
}

export function displayReceivedMessage(message) {
  // First bot message ever: run the one-time coach explaining what a bot
  // message is. The coach overlay (z-index 13000) sits above this popup
  // (9999), so it reads first; closing it reveals the message underneath.
  const looksLikeBot = message.isBot ||
    (message.senderName && (message.senderName.includes('_') || /\d{4}$/.test(message.senderName)));
  if (looksLikeBot && window.zxNudge?.showOnce) {
    window.zxNudge.showOnce('botmsg', {
      tag: t('nudge.botmsg_tag', 'SOMEONE IS TALKING TO YOU'),
      steps: [
        { h: t('nudge.botmsg_1_h', 'That message is from another trader.'),
          b: t('nudge.botmsg_1_b', 'Everyone on the floor holds values, makes offers, and talks. This trader just reached out to you.') },
        { h: t('nudge.botmsg_2_h', "Answer it — or don't."),
          b: t('nudge.botmsg_2_b', 'You can reply, trade with them, or ignore them. What you say and do shapes how the room treats you.') },
      ],
      cta: { label: t('nudge.botmsg_cta', 'GOT IT') },
    });
  }

  // Remove any existing overlay first
  const existingOverlay = document.getElementById('messageOverlay');
  if (existingOverlay) {
    existingOverlay.remove();
  }

  const overlay = document.createElement('div');
  overlay.id = 'messageOverlay';
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
  overlay.style.display = 'flex';
  overlay.style.justifyContent = 'center';
  overlay.style.alignItems = 'center';
  overlay.style.zIndex = '9999';

  const messageElement = document.createElement('div');
  messageElement.style.backgroundColor = 'black';
  messageElement.style.padding = '20px';
  messageElement.style.borderRadius = '10px';
  messageElement.style.maxWidth = '80%';
  messageElement.style.maxHeight = '70%';
  messageElement.style.color = '#00ff00';
  messageElement.style.fontFamily = 'bithigh, sans-serif';
  messageElement.style.border = '2px solid #00ff00';
  messageElement.style.overflow = 'hidden';
  messageElement.style.display = 'flex';
  messageElement.style.flexDirection = 'column';
  
  // Generate unique IDs for this message
  const messageId = `msg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  const respondBtnId = `respond_${messageId}`;
  const closeBtnId = `close_${messageId}`;
  
  messageElement.innerHTML = `
    <div style="
      border-bottom: 1px solid #00ff00;
      padding-bottom: 10px;
      margin-bottom: 15px;
    ">
      <p style="
        margin: 0;
        font-size: 14px;
        font-weight: bold;
      ">${t('messageSend.newMessageFrom')}</p>
      <p style="
        margin: 5px 0 0 0;
        font-size: 16px;
        color: #66ff66;
      ">${message.senderName || t('messageSend.unknown')}</p>
    </div>
    
    <div style="
      flex: 1;
      overflow-y: auto;
      max-height: 300px;
      padding-right: 10px;
      margin-bottom: 15px;
    ">
      <div style="
        font-size: 12px;
        line-height: 1.4;
        word-wrap: break-word;
        white-space: pre-wrap;
      ">${message.content || ''}</div>
    </div>
    
    <div style="
      display: flex;
      gap: 10px;
      justify-content: space-between;
      border-top: 1px solid #00ff00;
      padding-top: 15px;
    ">
      <button id="${respondBtnId}" style="
        flex: 1;
        padding: 10px 20px; 
        background-color: rgba(0, 255, 0, 0.2);
        font-family: 'bithigh', Arial, sans-serif;
        border: 1px solid #00ff00; 
        color: #00ff00; 
        font-weight: bold; 
        cursor: pointer; 
        border-radius: 5px;
        font-size: 12px;
        transition: background-color 0.3s;
      " onmouseover="this.style.backgroundColor='rgba(0, 255, 0, 0.3)'" 
         onmouseout="this.style.backgroundColor='rgba(0, 255, 0, 0.2)'">
        ${t('messageSend.reply')}
      </button>
      
      <button id="${closeBtnId}" style="
        flex: 1;
        padding: 10px 20px; 
        background-color: rgba(0, 255, 0, 0.8);
        font-family: 'bithigh', Arial, sans-serif;
        border: none; 
        color: black; 
        font-weight: bold; 
        cursor: pointer; 
        border-radius: 5px;
        font-size: 12px;
        transition: background-color 0.3s;
      " onmouseover="this.style.backgroundColor='rgba(0, 255, 0, 0.9)'" 
         onmouseout="this.style.backgroundColor='rgba(0, 255, 0, 0.8)'">
        ${t('messageSend.markAsRead')}
      </button>
    </div>
  `;

  overlay.appendChild(messageElement);
  document.body.appendChild(overlay);

  // Track popup state
  if (window.popupTracker) {
    const popupHandle = window.popupTracker.trackElement(overlay, 'received-message');
  }

  // Get the actual DOM elements using the unique IDs
  const closeButton = document.getElementById(closeBtnId);
  const respondButton = document.getElementById(respondBtnId);
  
  if (!closeButton || !respondButton) {
    console.error('Failed to find message buttons');
    return;
  }

  // Define cleanup function
  const closeMessage = () => {
    try {
      if (overlay && overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    } catch (error) {
      console.error('Error closing message overlay:', error);
    }
    // Remove event listeners
    document.removeEventListener('keydown', handleEscape);
  };
  
  // Attach event listeners using the actual DOM elements
  const handleCloseClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    closeMessage();
  };

  const handleRespondClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    try {
      // Check if the sender is a bot
      const isBot = await checkIfBotSender(message.senderId, message.senderName);
      
      if (isBot) {
        closeMessage();
        // Use the global botChatHandler instance
        if (window.botChatHandler) {
          window.botChatHandler.startChat(message.senderId, message.senderName);
        } else {
          // Fallback: import dynamically
          import('./botChatHandler.js').then(({ botChatHandler }) => {
            botChatHandler.startChat(message.senderId, message.senderName);
          });
        }
      } else {
        console.log('Cannot chat with human players');
        alert(t('messageSend.onlyChatBots'));
        closeMessage();
      }
    } catch (error) {
      console.error('Error handling respond click:', error);
      closeMessage();
    }
  };

  // ON THE FLOOR: a trader who invites you to bid or swap gets a button that
  // takes you to what they hold. The message used to offer only REPLY and
  // MARK AS READ, so "bid on one of my shares" led nowhere (tester: "the link
  // in the bot message to buy a stock or swap didn't fire or wasn't shown").
  // The floor provides the hook; the classic pages do not, and are unchanged.
  const traderId = message.senderId || message.senderPortfolioId || message.botData?._id;
  const floorTrade = window.zxFloorTrade;
  if (floorTrade?.canOpen?.(traderId)) {
    const tradeBtn = document.createElement('button');
    tradeBtn.textContent = floorTrade.label;
    tradeBtn.style.cssText = `width:100%;margin-bottom:10px;padding:14px 20px;background:#fcba03;border:none;
      color:#000;font-family:'bithigh',Arial,sans-serif;font-weight:bold;font-size:13px;border-radius:5px;cursor:pointer;`;
    const goTrade = (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeMessage();
      try { floorTrade.open(traderId, message); } catch (err) { console.error('floor trade link:', err); }
    };
    tradeBtn.addEventListener('click', goTrade);
    closeButton.parentNode.parentNode.insertBefore(tradeBtn, closeButton.parentNode);
  }

  // Add event listeners
  closeButton.addEventListener('click', handleCloseClick);
  closeButton.addEventListener('touchend', handleCloseClick);
  respondButton.addEventListener('click', handleRespondClick);
  respondButton.addEventListener('touchend', handleRespondClick);
  
  // Handle overlay click (close when clicking outside)
  const handleOverlayClick = (e) => {
    if (e.target === overlay) {
      closeMessage();
    }
  };
  overlay.addEventListener('click', handleOverlayClick);
  
  // Handle escape key
  const handleEscape = (e) => {
    if (e.key === 'Escape') {
      closeMessage();
    }
  };
  document.addEventListener('keydown', handleEscape);

  // Store references for cleanup (optional - for debugging)
  overlay._messageData = {
    messageId,
    senderId: message.senderId,
    senderName: message.senderName,
    closeMessage,
    respondBtnId,
    closeBtnId
  };
}

// Helper function to check if sender is a bot
async function checkIfBotSender(senderId, senderName) {
  try {
    // Method 1: Check if sender name contains bot patterns
    if (senderName && (senderName.includes('_') || senderName.match(/\d{4}$/))) {
      return true;
    }
    
    // Method 2: Check local cache
    if (window.botStatusCache && window.botStatusCache.has(senderId)) {
      const cached = window.botStatusCache.get(senderId);
      if (Date.now() - cached.timestamp < 300000) { // 5 minute cache
        return cached.isBot;
      }
    }
    
    // Method 3: API call as fallback
    const token = localStorage.getItem('authToken');
    if (!token || !senderId) return false;
    
    const response = await fetch(`${apiBaseUrl}/api/portfolio/${senderId}/info`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      
      // Cache the result
      if (!window.botStatusCache) {
        window.botStatusCache = new Map();
      }
      window.botStatusCache.set(senderId, {
        isBot: data.isBot,
        timestamp: Date.now()
      });
      
      return data.isBot;
    }
  } catch (error) {
    console.error('Error checking bot status:', error);
  }
  
  return false;
}

// New chat functions
export function openBotChat(botId, botName) {
  // Remove any existing chat
  const existingChat = document.getElementById('botChatPopup');
  if (existingChat) {
    existingChat.remove();
  }

  activeChatSession = {
    botId: botId,
    botName: botName,
    chatId: null,
    exchangeCount: 0,
    maxExchanges: 4
  };

  const chatPopup = document.createElement('div');
  chatPopup.id = 'botChatPopup';
  chatPopup.style.cssText = `
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 350px;
    height: 500px;
    background-color: black;
    border: 2px solid #00ff00;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    z-index: 10000;
    font-family: 'bithigh', sans-serif;
    color: #00ff00;
  `;

  chatPopup.innerHTML = `
    <div style="
      padding: 15px;
      border-bottom: 1px solid #00ff00;
      display: flex;
      justify-content: space-between;
      align-items: center;
    ">
      <div>
        <div style="font-size: 14px; font-weight: bold;">${t('messageSend.conversationWith')} ${botName}</div>
        <div style="font-size: 11px; color: #66ff66;" id="chatStatus">
          ${activeChatSession.maxExchanges - activeChatSession.exchangeCount} ${t('messageSend.messagesRemaining')}
        </div>
      </div>
      <button id="closeChatBtn" style="
        background: none;
        border: 1px solid #00ff00;
        color: #00ff00;
        padding: 5px 10px;
        cursor: pointer;
        border-radius: 3px;
        font-size: 12px;
      ">✕</button>
    </div>
    
    <div id="chatMessages" style="
      flex: 1;
      overflow-y: auto;
      padding: 15px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    "></div>
    
    <div style="
      padding: 15px;
      border-top: 1px solid #00ff00;
      display: flex;
      gap: 10px;
    ">
      <input type="text" id="chatInput" placeholder="${t('messageSend.typeYourMessage')}" style="
        flex: 1;
        background: rgba(0, 255, 0, 0.1);
        border: 1px solid #00ff00;
        color: #00ff00;
        padding: 8px;
        border-radius: 3px;
        font-family: inherit;
      " maxlength="280">
      <button id="sendChatBtn" style="
        background: rgba(0, 255, 0, 0.2);
        border: 1px solid #00ff00;
        color: #00ff00;
        padding: 8px 15px;
        cursor: pointer;
        border-radius: 3px;
        font-weight: bold;
      ">${t('messageSend.send')}</button>
    </div>
  `;

  document.body.appendChild(chatPopup);

  // Track popup state
  if (window.popupTracker) {
    const popupHandle = window.popupTracker.trackElement(chatPopup, 'bot-chat');
  }

  // Add event listeners
  document.getElementById('closeChatBtn').addEventListener('click', closeBotChat);
  document.getElementById('sendChatBtn').addEventListener('click', sendChatMessage);
  document.getElementById('chatInput').addEventListener('keypress', (e) => {
    if (e.key === 'Enter') sendChatMessage();
  });

  // Add initial bot greeting
  addChatMessage('bot', (t('messageSend.botGreeting', { name: botName }) || `Good day I'm ${botName}. What's on your mind?`));
}

async function sendChatMessage() {
  const input = document.getElementById('chatInput');
  const message = input.value.trim();
  
  if (!message || !activeChatSession) return;
  
  if (activeChatSession.exchangeCount >= activeChatSession.maxExchanges) {
    addChatMessage('system', t('messageSend.chatLimitReached'));
    return;
  }

  // Add user message to chat
  addChatMessage('user', message);
  input.value = '';
  input.disabled = true;
  document.getElementById('sendChatBtn').disabled = true;

  try {
    const userId = localStorage.getItem('portfolioId');
    const authToken = localStorage.getItem('token');

    if (!userId) {
      console.error('No portfolioId found in localStorage');
      addChatMessage('system', 'Error: User not logged in');
      input.disabled = false;
      document.getElementById('sendChatBtn').disabled = false;
      return;
    }

    const response = await fetch(`${apiBaseUrl}/api/sys/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify({
        botId: activeChatSession.botId,
        userId: userId,
        message: message,
        chatId: activeChatSession.chatId
      })
    });

    const data = await response.json();
    
    if (data.success) {
      activeChatSession.chatId = data.chatId;
      activeChatSession.exchangeCount++;
      
      // Add bot response
      addChatMessage('bot', data.response);
      
      // Update status
      const remaining = data.exchangesRemaining;
      document.getElementById('chatStatus').textContent = 
        remaining > 0 ? `${remaining} ${t('messageSend.messagesRemaining')}` : t('messageSend.chatEnded');
      
      if (data.chatEnded) {
        input.disabled = true;
        document.getElementById('sendChatBtn').disabled = true;
        addChatMessage('system', t('messageSend.chatEndedThanks'));
      } else {
        input.disabled = false;
        document.getElementById('sendChatBtn').disabled = false;
        input.focus();
      }
    } else {
     addChatMessage('system', t('messageSend.error') + ': ' + (data.error || t('messageSend.failedToSend')));
      input.disabled = false;
      document.getElementById('sendChatBtn').disabled = false;
    }
  } catch (error) {
    console.error('Chat error:', error);
    addChatMessage('system', t('messageSend.connectionError'));
    input.disabled = false;
    document.getElementById('sendChatBtn').disabled = false;
  }
}

function addChatMessage(sender, content) {
  const messagesDiv = document.getElementById('chatMessages');
  const messageEl = document.createElement('div');
  
  const styles = {
    user: {
      align: 'flex-end',
      bg: 'rgba(0, 255, 0, 0.2)',
      border: '1px solid #00ff00',
      color: '#00ff00'
    },
    bot: {
      align: 'flex-start',
      bg: 'rgba(255, 255, 255, 0.1)',
      border: '1px solid #666',
      color: '#fff'
    },
    system: {
      align: 'center',
      bg: 'transparent',
      border: 'none',
      color: '#666'
    }
  };
  
  const style = styles[sender] || styles.system;
  
  messageEl.style.cssText = `
    align-self: ${style.align};
    max-width: 85%;
    padding: 8px 12px;
    background: ${style.bg};
    border: ${style.border};
    border-radius: 3px;
    color: ${style.color};
    font-size: 12px;
    word-wrap: break-word;
  `;
  
  messageEl.textContent = content;
  messagesDiv.appendChild(messageEl);
  messagesDiv.scrollTop = messagesDiv.scrollHeight;
}

function closeBotChat() {
  const chatPopup = document.getElementById('botChatPopup');
  if (chatPopup) {
    chatPopup.remove();
  }
  
  // End chat session on backend
  if (activeChatSession && activeChatSession.chatId) {
    fetch(`${apiBaseUrl}/api/bot/endChat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify({ chatId: activeChatSession.chatId })
    }).catch(err => console.error('Error ending chat:', err));
  }
  
  activeChatSession = null;
}

